import {
  PremiumPubBannerSkeletonImage,
  PremiumPubBannerWrapper,
} from "./style";
import PremiumPubBannerInfoSkeleton from "./components/banner-info/skeleton";

const PremiumPubBannerSkeleton = () => {
  return (
    <PremiumPubBannerWrapper>
      <PremiumPubBannerSkeletonImage />
      <PremiumPubBannerInfoSkeleton />
    </PremiumPubBannerWrapper>
  );
};

export default PremiumPubBannerSkeleton;
